import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconH3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconH3"><Path d="M13.5 4.5V12V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 12H2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 4.5V12V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20 15C21.3807 15 22.5 13.9926 22.5 12.75C22.5 11.5074 21.3807 10.5 20 10.5C18.6193 10.5 17.5 11.5074 17.5 12.75M20 15C21.3807 15 22.5 16.0074 22.5 17.25C22.5 18.4926 21.3807 19.5 20 19.5C18.6193 19.5 17.5 18.4926 17.5 17.25M20 15H18.75" stroke="currentColor"/></CentralIconBase>;
});

export default IconH3;
